/* =====================================================================
   Zodiac product page — the sticky Add to cart bar.

   One job. On a phone the buy row sits below the gallery and the option
   groups, which is most of a screen and a half of scrolling, so the bar
   keeps a copy of the button on the glass until the real one comes into
   view and then gets out of the way.

   Two rules it follows, both of which are the reason this is JS and not a
   Liquid partial:

   1. It never has an opinion of its own. Label, price and disabled state
      are mirrored from the real submit button, which Dawn's variant script
      rewrites on every option change. A bar that decided for itself
      whether a variant was in stock would be wrong the moment someone
      picked a sold-out size.

   2. It is appended to <body>. position:fixed resolves against the nearest
      transformed ancestor, and Dawn puts `animate--slide-in` -- a
      transform -- on .product__info-wrapper. A bar rendered inside the
      product form would be fixed to that box instead of the viewport, and
      would look correct right up until someone turned the reveal
      animation on in the theme editor.

   Loaded only from sections/main-product.liquid.
   ===================================================================== */
(function () {
  'use strict';

  var PHONE = '(max-width: 749px)';

  /* The store's own cart glyph (assets/icon-cart.svg) with a plus set just
     off its bottom-right corner. Inline because the bar is built here rather
     than in Liquid and cannot use inline_asset_content.

     snippets/zbag-plus.liquid is the same two paths for the surfaces that
     CAN render Liquid -- today the cart page's "Complete the setup" rows.
     Change one, change the other.

     The plus is placed clear of the bag rather than notched into it: the bag
     occupies x 11.8-29.2, y 6.5-29.5 of the 40x40 box, so arms centred on
     (31,31) clear its right edge and its bottom at this stroke width while
     still tucking into the corner. */
  var CART_ICON = '<svg class="zpdp-dock__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" aria-hidden="true" focusable="false">'
    + '<path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"/>'
    + '<path stroke="currentColor" stroke-width="2" stroke-linecap="square" d="M27.8 31h6.4M31 27.8v6.4"/>'
    + '</svg>';

  /* The picture that is currently on screen in the gallery, asked for at a
     size that suits a 64px tile rather than reusing the 1946px hero. Dawn
     marks the visible slide .is-active and keeps doing so as you swipe, so
     the tile tracks the gallery instead of freezing on the first shot. */
  function thumbSrc() {
    var list = document.querySelector('.product .product__media-list');
    var img = (list && (list.querySelector('.product__media-item.is-active img')
                     || list.querySelector('.product__media-item img')))
           || document.querySelector('.product .product__media img');
    var src = img && (img.currentSrc || img.src);
    if (!src) return null;
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', '200');
      return u.href;
    } catch (e) {
      return src;
    }
  }

  function build(realBtn, buyRow, priceEl) {
    var dock = document.createElement('div');
    dock.className = 'zpdp-dock';
    dock.setAttribute('data-zpdp-dock', '');

    /* Far left the picture, far right the button, the price against it.
       The picture is an <img> at its own aspect ratio -- height fixed, width
       whatever the shot is -- so a wide photo is not cropped into a square
       and a tall one is not stretched into it. */
    var thumb = document.createElement('img');
    thumb.className = 'zpdp-dock__thumb';
    thumb.alt = '';
    thumb.setAttribute('aria-hidden', 'true');
    thumb.decoding = 'async';

    /* The name, so the bar still says WHAT is being bought once the head has
       scrolled off. aria-hidden with the rest of the bar: the button already
       carries an accessible name, and a screen reader is not lost on this
       page the way a thumb scrolling past the fold is. */
    var name = document.createElement('span');
    name.className = 'zpdp-dock__name';
    name.setAttribute('aria-hidden', 'true');
    /* Two queries, not one selector list. Dawn's .product__title holds the
       name TWICE -- an <h1> and a linked <h2> after it -- and a comma list
       returns the first match in DOCUMENT order, which is the wrapper
       holding both. That put the title in the bar twice. */
    var titleEl = document.querySelector('.product .product__title h1')
      || document.querySelector('.product .product__title');
    name.textContent = titleEl ? titleEl.textContent.trim() : '';

    var price = document.createElement('span');
    price.className = 'zpdp-dock__price';
    price.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zpdp-dock__btn';
    btn.innerHTML = CART_ICON;

    /* The words are still there, just not drawn. An icon-only button has no
       accessible name, and "Sold out" is a thing the bar has to be able to
       say -- the stylesheet un-hides this and drops the glyph when the
       button is disabled. */
    var label = document.createElement('span');
    label.className = 'zpdp-dock__label';
    btn.appendChild(label);

    dock.appendChild(thumb);
    dock.appendChild(name);
    dock.appendChild(price);
    dock.appendChild(btn);
    document.body.appendChild(dock);

    /* The real button owns the click. Forwarding it rather than posting to
       /cart/add here means the variant id, the quantity, the line-item
       properties and the drawer that opens afterwards are all still
       Dawn's product-form.js -- there is one add-to-cart path on this
       page, not two that have to agree. */
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      realBtn.click();
    });

    function syncThumb() {
      var next = thumbSrc();
      if (!next) { thumb.hidden = true; return; }
      thumb.hidden = false;
      if (next !== thumb.getAttribute('src')) thumb.setAttribute('src', next);
    }

    function syncLabel() {
      var text = (realBtn.querySelector('span') || realBtn).textContent.trim();
      label.textContent = text;
      btn.setAttribute('aria-label', text);

      /* Busy and sold out look identical from here, and Dawn disables the
         button for both. There are THREE ways it goes disabled and only one
         of them means sold out:
           - product-form.js:26   an add is in flight  (.loading is set)
           - product-info.js:84   a variant fetch is in flight (nothing is set)
           - product-form.js:124  the variant cannot be bought

         So the class is not enough -- reading disabled alone flashed the
         sold-out treatment on every tap AND on every size change. What
         actually separates them is the WORD: toggleSubmitButton only writes
         text when it has one to write, so the label still says "Add to cart"
         through both transients and only changes when the answer is really
         no. Compared against window.variantStrings so it stays right in any
         language; if that is missing we fall back to the old, blunter rule. */
      var vs = window.variantStrings || {};
      var known = !!(vs.soldOut || vs.unavailable);
      var off = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      var saysNo = known && (text === vs.soldOut || text === vs.unavailable);
      var busy = realBtn.classList.contains('loading') || (off && known && !saysNo);
      var soldOut = off && !busy;
      btn.disabled = busy || soldOut;
      btn.classList.toggle('is-busy', busy);
      btn.classList.toggle('is-out', soldOut);
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');

      /* The price rides along because on this layout it has scrolled off
         the top by the time the bar matters. It is dropped only when the
         button is not an offer to buy -- "Sold out $24" reads as a taunt --
         and never merely because a request is in flight. */
      var money = priceEl ? priceEl.querySelector('.price-item--sale, .price-item--regular') : null;
      price.textContent = !soldOut && money ? money.textContent.trim() : '';
    }

    syncLabel();
    syncThumb();

    /* Dawn rewrites the button's text and its disabled attribute in place
       on every variant change, and never fires an event we could listen
       for instead. */
    new MutationObserver(syncLabel).observe(realBtn, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
      /* class is in here for .loading; without it the busy state above is
         invisible to us, because attributeFilter applies to the subtree too. */
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
    if (priceEl) {
      new MutationObserver(syncLabel).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    /* Swiping the gallery moves .is-active; a variant change replaces the
       slides outright. Both are covered by watching the list. */
    var list = document.querySelector('.product .product__media-list');
    if (list) {
      new MutationObserver(syncThumb).observe(list, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'src']
      });
    }

    /* Up while the real row is off screen, down the moment it arrives. The
       80px bottom inset hands over just before the two buttons would
       overlap, rather than at the instant the row's first pixel appears. */
    var io = new IntersectionObserver(function (entries) {
      dock.classList.toggle('is-up', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(buyRow);

    /* data-live is what takes it out of display:none. Setting it a frame
       late means the first paint is the translated-down state, so the bar
       slides up instead of appearing already in place. */
    requestAnimationFrame(function () { dock.setAttribute('data-live', ''); });
  }

  function init() {
    if (!window.matchMedia || !window.matchMedia(PHONE).matches) return;
    if (typeof IntersectionObserver !== 'function') return;
    if (document.querySelector('[data-zpdp-dock]')) return;

    var buyRow = document.querySelector('.product .zc-buy-row');
    var realBtn = buyRow && buyRow.querySelector('.product-form__submit');
    if (!buyRow || !realBtn) return;

    var priceEl = document.querySelector('.product [id^="price-"]');
    build(realBtn, buyRow, priceEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
